import type { Content, ContentTileFields } from '@beat-venues/common-types';
import { mockMetadata } from './base.mock';
import { mockContentCtaWithInternalEntryToContentPage } from './content-cta.mock';
import { mockContentIconBase } from './content-icon.mock';
import { mockContentImageFull } from './content-image.mock';
import { mockContentRichTextWithParagraph } from './content-rich-text.mock';

export const mockContentTileWithImage: Content<
    'contentTile',
    ContentTileFields
> = {
    sys: {
        id: '6winRgszgbsg87jY13EgdO',
        contentType: {
            sys: {
                id: 'contentTile',
            },
        },
        locale: 'nl',
    },
    metadata: mockMetadata,
    fields: {
        title: 'Tile with image',
        description: mockContentRichTextWithParagraph.fields.content,
        cta: mockContentCtaWithInternalEntryToContentPage,
        image: mockContentImageFull,
    },
};

export const mockContentTileWithIcon: Content<
    'contentTile',
    ContentTileFields
> = {
    ...mockContentTileWithImage,
    fields: {
        title: 'Tile with icon',
        description: mockContentTileWithImage.fields.description,
        cta: mockContentTileWithImage.fields.cta,
        image: mockContentIconBase,
    },
};
